@use '@lib/assets/styles/main.scss' as *;

.root {
  display: flex;
  align-items: center;
  justify-content: center;
  svg, img {
    display: block;
  }
  svg {
    shape-rendering: auto;
    display: block;
    background: transparent;
  }
}

.spinner {
  animation: rotate 2s linear infinite;
}

.path {
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
